// Cooperative Learning "Stage" pages, rendered in-app by CooperativeLearningStage.vue.
//
// Transcribed from the Word documents in docs/stories/update-resource-links/:
//   primaryStage1 - Primary_Links_for_each_Unit.docx
//   ppStage1      - PP_Links_for_each_Unit.docx
//   ppStage2      - PP2_Links_for_each_Unit.docx
//
// Each stage: { title, intro, units: [] }
// Each unit:  { number, sticker, links: [{ label, url }], notes: [String] }

/* eslint-disable max-len */
const stages = {
  primaryStage1: {
    title: 'Cooperative Learning Links - Stage 1 (Primary)',
    intro: 'The following links can be used with each unit.',
    units: [
      {
        number: 2,
        sticker: 'Building our team',
        links: [
          { label: 'Listening link', url: 'https://www.ted.com/talks/ted_ed_4_things_all_great_listeners_know' },
        ],
        notes: [],
      },
      {
        number: 3,
        sticker: 'Working as a team',
        links: [
          { label: 'Finding Nemo', url: 'https://www.youtube.com/watch?v=k8ZKO5AwF80&t=17s' },
        ],
        notes: [],
      },
      {
        number: 4,
        sticker: 'Contributing to our team',
        links: [
          { label: 'Use the link from 2:12 - 3:58', url: 'https://www.youtube.com/watch?v=VfaIsP90xGA' },
        ],
        notes: [],
      },
      {
        number: 5,
        sticker: 'Bonding as a team',
        links: [
          { label: 'Pixar - The Birds', url: 'https://www.youtube.com/watch?v=HJg10H39FhE&t=195s' },
        ],
        notes: [
          'This is particularly good for discussing belonging and bonding as a team:',
          'What makes a group feel like a team?',
          'Who gets included and excluded?',
          'Are the birds actually working together, or just following one another?',
          'What happens when everyone follows the same idea?',
        ],
      },
      {
        number: 6,
        sticker: 'Consensus and Cooperation',
        links: [
          { label: 'Mr Saad', url: 'https://www.youtube.com/watch?v=3IQRmw7cvUU&t=83s' },
        ],
        notes: [
          'How do we cooperate and what does cooperation get accomplished? Mr Saad explains how working together is way better than working against one another.',
        ],
      },
      {
        number: 7,
        sticker: 'Kindness and trust',
        links: [
          { label: 'Kindness Boomerang', url: 'https://www.youtube.com/watch?v=nwAYpLVyeFU&list=RDnwAYpLVyeFU&start_radio=1' },
        ],
        notes: [],
      },
      {
        number: 8,
        sticker: 'Developing Resilience',
        links: [
          { label: 'Resilience for kids', url: 'https://youtu.be/fE2LILYujKo' },
        ],
        notes: [],
      },
      {
        number: 9,
        sticker: 'Safety, belonging and Learning',
        links: [
          { label: 'Chick Hatches', url: 'https://www.youtube.com/shorts/rb1LP0E3cVc' },
        ],
        notes: [],
      },
    ],
  },

  ppStage1: {
    title: 'Cooperative Learning Links - Stage 1 (Post Primary)',
    intro: 'The following links can be used with each unit.',
    units: [
      {
        number: 2,
        sticker: 'Building our team',
        links: [
          { label: 'Listening link', url: 'https://www.ted.com/talks/ted_ed_4_things_all_great_listeners_know' },
        ],
        notes: [],
      },
      {
        number: 3,
        sticker: 'Working as a team',
        links: [
          { label: 'Finding Nemo', url: 'https://www.youtube.com/watch?v=k8ZKO5AwF80&t=17s' },
          { label: 'How teams fill the gap - how we simply help one another in a team. Explores how relying only on personal motivation fails, and how supportive teams keep one another going when motivation dips.', url: 'https://www.youtube.com/watch?v=jACYAioYqgI' },
        ],
        notes: [],
      },
      {
        number: 4,
        sticker: 'Contributing to our team',
        links: [
          { label: 'Use the link from 2:12 - 3:58', url: 'https://www.youtube.com/watch?v=VfaIsP90xGA' },
          { label: 'TrueSport Ambassador and two-time Olympic gold medalist DeeDee Trotter shares the three most important things about being a great teammate.', url: 'https://truesport.org/teamwork/deedee-trotter-talks-teamwork/' },
          { label: 'How can a team achieve extraordinary things? - Invictus', url: 'https://clip.cafe/invictus-2009/how-do-inspire-team-do-their-best/' },
          { label: 'How teams achieve extraordinary things - Invictus (8 mins)', url: 'https://www.youtube.com/watch?v=MBH1GmLGq5g' },
        ],
        notes: [],
      },
      {
        number: 5,
        sticker: 'Bonding as a team',
        links: [
          { label: 'Pixar - The Birds', url: 'https://www.youtube.com/watch?v=HJg10H39FhE&t=195s' },
          { label: 'Olympic medalist Elizabeth Beisel', url: 'https://vimeo.com/339627462' },
        ],
        notes: [
          'This is particularly good for discussing belonging and bonding as a team:',
          'What makes a group feel like a team?',
          'Who gets included and excluded?',
          'Are the birds actually working together, or just following one another?',
          'What happens when everyone follows the same idea?',
        ],
      },
      {
        number: 6,
        sticker: 'Consensus and Cooperation',
        links: [
          { label: 'Teamwork video', url: 'https://www.youtube.com/watch?v=EMgwoX7qTmY&t=39s' },
        ],
        notes: [],
      },
      {
        number: 7,
        sticker: 'Kindness and trust',
        links: [
          { label: 'The Life Vest', url: 'https://www.youtube.com/watch?v=nwAYpLVyeFU&list=RDnwAYpLVyeFU&start_radio=1' },
        ],
        notes: [],
      },
      {
        number: 8,
        sticker: 'Developing Resilience',
        links: [
          { label: 'Artemis II crew share stories of logistical, spiritual and emotional preparation', url: 'https://www.youtube.com/watch?v=JagNVCJlrFk' },
          { label: 'A true leader understands the importance of a strong team', url: 'https://www.youtube.com/shorts/iQkyNVvA0YY' },
        ],
        notes: [],
      },
      {
        number: 9,
        sticker: 'Safety, belonging and Learning',
        links: [
          { label: 'Chick Hatches', url: 'https://www.youtube.com/shorts/rb1LP0E3cVc' },
        ],
        notes: [],
      },
    ],
  },

  ppStage2: {
    title: 'Cooperative Learning Links - Stage 2 (Post Primary)',
    intro: 'The following links can be used with each unit.',
    units: [
      {
        number: 2,
        sticker: 'Building our team',
        links: [
          { label: 'Olivia Rodrigo - Drivers License', url: 'https://www.youtube.com/watch?v=ZmDBbnmKpqQ' },
          { label: 'The Art of Listening', url: 'https://www.youtube.com/watch?v=qpnNsSyDw-g' },
        ],
        notes: [],
      },
      {
        number: 3,
        sticker: 'Working as a team',
        links: [
          { label: 'Finding Nemo', url: 'https://www.youtube.com/watch?v=k8ZKO5AwF80&t=17s' },
          { label: 'How teams fill the gap - how we simply help one another in a team. Explores how relying only on personal motivation fails, and how supportive teams keep one another going when motivation dips.', url: 'https://www.youtube.com/watch?v=jACYAioYqgI' },
          { label: 'Paraphrasing and Ensuring Understanding', url: 'https://www.youtube.com/watch?v=Lh7xG4qHIGQ' },
        ],
        notes: [],
      },
      {
        number: 4,
        sticker: 'Contributing to our team',
        links: [
          { label: 'Use the link from 2:12 - 3:58', url: 'https://www.youtube.com/watch?v=VfaIsP90xGA' },
          { label: 'TrueSport Ambassador and two-time Olympic gold medalist DeeDee Trotter shares the three most important things about being a great teammate.', url: 'https://truesport.org/teamwork/deedee-trotter-talks-teamwork/' },
          { label: 'How can a team achieve extraordinary things? - Invictus', url: 'https://clip.cafe/invictus-2009/how-do-inspire-team-do-their-best/' },
          { label: 'How teams achieve extraordinary things - Invictus (8 mins)', url: 'https://www.youtube.com/watch?v=MBH1GmLGq5g' },
        ],
        notes: [],
      },
      {
        number: 5,
        sticker: 'Bonding as a team',
        links: [
          { label: 'Pixar - The Birds', url: 'https://www.youtube.com/watch?v=HJg10H39FhE&t=195s' },
          { label: 'Olympic swimmer Peter Vanderkaay talks about the importance of teamwork (even in more individual sports like swimming). The Importance of "WE" instead of "ME"!', url: 'https://truesport.org/video/the-importance-of-we-over-me-peter-vanderkaay' },
        ],
        notes: [
          'This is particularly good for discussing belonging and bonding as a team:',
          'What makes a group feel like a team?',
          'Who gets included and excluded?',
          'Are the birds actually working together, or just following one another?',
          'What happens when everyone follows the same idea?',
        ],
      },
      {
        number: 6,
        sticker: 'Consensus and Cooperation',
        links: [
          { label: 'Perfect example of cooperation in teamwork - discuss how the team reached their goal by working together!', url: 'https://www.youtube.com/watch?v=EMgwoX7qTmY&t=39s' },
          { label: 'Artemis II crew share stories of logistical, spiritual and emotional preparation', url: 'https://www.youtube.com/watch?v=JagNVCJlrFk' },
        ],
        notes: [],
      },
      {
        number: 7,
        sticker: 'Kindness and trust',
        links: [
          { label: 'The Life Vest', url: 'https://www.youtube.com/watch?v=nwAYpLVyeFU&list=RDnwAYpLVyeFU&start_radio=1' },
          { label: 'Handling put downs (Taylor Swift interview)', url: 'https://www.npr.org/2014/10/31/359827368/anything-that-connects-a-conversation-with-taylor-swift' },
        ],
        notes: [
          'Use the section around 1 - 4 minutes.',
          'The really useful message for students is essentially: people may say things about you, but you decide how much power those words have over you.',
          'That gives you a great discussion with 15-year-olds:',
          'Why do put-downs affect us so much?',
          'What happens when we give someone a reaction?',
          'Is "ignoring it" always the best response?',
          'What is the difference between being resilient and just putting up with someone treating you badly?',
          'How can you "shake it off" without pretending you aren\'t hurt?',
        ],
      },
      {
        number: 8,
        sticker: 'Developing Resilience',
        links: [
          { label: 'A true leader understands the importance of a strong team', url: 'https://www.youtube.com/shorts/iQkyNVvA0YY' },
          { label: 'Will.i.am on resilience and coming together as a team', url: 'https://www.pbs.org/wnet/amanpour-and-company/video/will-i-am-on-his-new-single-inspired-by-global-resilience/' },
          { label: 'Ed Sheeran - One man can change the world', url: 'https://www.youtube.com/watch?v=woef-UeFtgQ' },
        ],
        notes: [],
      },
      {
        number: 9,
        sticker: 'Safety, belonging and Learning',
        links: [
          { label: 'Chick Hatches', url: 'https://www.youtube.com/shorts/rb1LP0E3cVc' },
          { label: 'Taylor Swift - never be ashamed of trying and getting back up after you mess up', url: 'https://abcnews.com/video/84816729/' },
          { label: 'Olympic swimmer Peter Vanderkaay talks about the importance of teamwork (even in more individual sports like swimming). The Importance of "WE" instead of "ME"!', url: 'https://truesport.org/video/the-importance-of-we-over-me-peter-vanderkaay' },
        ],
        notes: [],
      },
    ],
  },
};
/* eslint-enable max-len */

export default stages;



// WEBPACK FOOTER //
// ./src/data/cooperativeLearningStages.js